import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import ZapierAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/ZapierAppIcon';

import BetaListDialog from '../Dialogs/BetaListDialog';

const ZapierStratergy = {
  previewInfo: {
    name: 'Zapier',
    iconSvg: <ZapierAppIcon size="xlarge" />,
    newTab: true,
  },
  headerInfo: {
    name: 'Zapier',
    category: 'Connect Housecall Pro to thousands of apps with automated workflows',
    details: (
      <div>
        Zapier is an online automation tool that connects Housecall Pro to your favorite apps, such as Gmail, MailChimp,
        Sheets, and over 1,000 more. You can connect two or more apps to automate repetitive tasks without coding or
        relying on developers to build the integration. Move info between your web apps automatically, so you can focus
        on your most important work. It&apos;s and advanced tool for power Housecall Pro users. As you discover more
        tasks you want to automate, no sweat, just set up a Zap for each one.
        <br /> <br />
        Ready to try it out? Check out more of what&apos;s possible including some Zap templates{' '}
        <a href="https://zapier.com/help/basics/" target="_blank" rel="noreferrer">
          here
        </a>
        .
      </div>
    ),
    iconSvg: <ZapierAppIcon size="xlarge" />,
  },
  media: {
    youtubeId: 'yG90m3H_kgA',
  },
  sellingPoints: {
    headline: 'Zaps Connect the Apps You Use Every Day',
    description: '',
    unorderedPoints: [
      'Start workflows from any app',
      'Finish routine tasks automatically',
      'Simple, fill-in-the-blank setup',
    ],
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Not Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    title: 'Partner Pricing',
    description: (
      <Grid container spacing={8}>
        <Grid item>
          <Typography align="left" variant="body1">
            <a href="https://zapier.com/pricing" target="_blank" rel="noreferrer">
              https://zapier.com/pricing
            </a>
          </Typography>
        </Grid>
        <Grid item>
          <Typography align="center" color="textSecondary">
            To use the integration, you must have an account with Zapier. Plans from $0 - $799/month
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  supportContacts: [{ type: 'Email', contact: 'support@zapier.com' }],
  dialog: <BetaListDialog />,
};

export default ZapierStratergy;
